<template>
    <div class="flex">
        <!-- Filtering Event with users and sales behaviour  -->
        <div class="col-lg-2 col-md-2 col-xs-12 col-sm-12">
            <div>
                <label class="typo__label">Add Users</label>
                <multiselect v-model="selectedUserValue" :options="selectedUserOptions" :multiple="true"
                             :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                             placeholder="Pick some" label="name" track-by="name" :preselect-first="true">
                    <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single"
                                                                                             v-if="values.length &amp;&amp; !isOpen">{{
                            values.length
                        }} options selected</span></template>
                </multiselect>
                <div class="selected-filters">
                    <ul v-for="user in selectedUserValue" class="p-0 mt-1">
                        <li v-bind:style="{backgroundColor:user.color,color:'white', textAlign: 'center', wordBreak:'break-all', borderRadius: '5px', padding: '5px', alignItems: 'center', justifyContent: 'center',display:'flow-root'}">
                            {{ user.name }}<span class="closeSelectItems" @click="removeSelectedUserValue(user)">x</span>
                        </li>
                    </ul>
                </div>
            </div>
            <br/>
            <div>
                <label class="typo__label">Add Sales Activity</label>
                <multiselect v-model="selectedSalesValue" :options="selectedSalesBehaviourOptions" :multiple="true"
                             :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                             placeholder="Pick some" label="name" track-by="name" :preselect-first="true">
                    <template slot="selection" slot-scope="{ values, search, isOpen }">
                        <span class="multiselect__single"
                              v-if="values.length &amp;&amp; !isOpen">{{
                                values.length
                            }} options selected</span></template>
                </multiselect>
                <div class="selected-filters">
                    <ul v-for="sales in selectedSalesValue" class="p-0">
                        <li class="selectedSalesBehaviour"><span>{{ sales.name }}</span><span class="closeSelectItems" @click="removeSelectedSalesValue(sales)">x</span></li>
                    </ul>
                </div>
            </div>
            <br/>



            <div>
                <label class="typo__label">Contact Activities</label>
                <multiselect v-model="selectedContactBehavior" :options="allContactBehaviors" :multiple="true"
                             :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                             placeholder="Pick some" label="name" track-by="name" :preselect-first="true">
                    <template slot="selection" slot-scope="{ values, search, isOpen }">
                        <span class="multiselect__single"
                              v-if="values.length &amp;&amp; !isOpen">{{
                                values.length
                            }} options selected</span></template>
                </multiselect>
                <div class="selected-filters">
                    <ul v-for="contact in selectedContactBehavior" class="p-0">
                        <li v-bind:style="{color:'white', textAlign: 'center', wordBreak:'break-all', borderRadius: '5px', padding: '5px', alignItems: 'center', justifyContent: 'center',display:'flow-root'}" class="selectedSalesBehaviour">
                            <span>{{ contact.name }}</span><span class="closeSelectItems" @click="removeSelectedContact(contact)">x</span></li>
                    </ul>
                </div>
            </div>
            <br/>





            <div>
                <button @click.prevent="filterEvent()"
                        class="py-2 px-3 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none">
                    Filter Events
                </button>
            </div>
        </div>
        <!-- Filtering Event with users and sales behaviour  -->
        <!-- Adding Buttons  -->
        <div class="col-lg-10 col-md-10 col-xs-12 col-sm-12">
            <div class="flex add-item-save-btn-main-div align-items-center">
                <div class="w-50 p-2 text-sm" v-if="user.external_email">
                    <span v-if="alreadySynced">
                        Sync Status: <span style="color: #01b1af">Success!</span><br/>
                        Last Sync: <span style="color: #01b1af">{{ syncDate }}</span>
                    </span>
                    <span v-else>
                        Sync Status: <span style="color: #af0303">Not Synced</span>
                    </span>
                    <br/><a class="text-sm underline" href="javascript:void(0)" style="color: #01b1af" @click="connectExternalMail()">Calendar Sync Settings</a>
                </div>
                <div class="w-50 p-2 text-sm" v-else>
                    <span>
                    No External Email Service Is Connected!
                    </span>
                    <br/><a class="text-sm underline" href="javascript:void(0)" style="color: #01b1af" @click="connectExternalMail()">Calendar Sync Settings</a>
                </div>
                <div class="w-50 mr-2 d-flex align-items-center">
                    <multiselect class="calender-filter"
                                 v-model="selectedCalendarView" :options="this.calendarViewList"
                                 placeholder="Select Calendar View" label="name"
                                 track-by="name" @input="filterCalendarView">
                    </multiselect>
                </div>
                <button v-if="selectedCalendarView && canEdit" @click.prevent="manageDefaultView"
                        class="py-2 px-3 mr-1 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none">
                    {{ selectedCalendarView.is_default ? 'Remove as Default View' : 'Set as Default View' }}
                </button>
                <button v-if="selectedCalendarView && canDelete" @click.prevent="removeCalenderView"
                        class="py-2 px-3 mr-1 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none">
                    Delete View
                </button>
                <button v-if="selectedCalendarView && canEdit" @click.prevent="shareCalendarView"
                        class="py-2 px-3 mr-1 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none">
                    Share View
                </button>
                <button v-if="canEdit" @click.prevent="openAddItem"
                        class="py-2 px-3 mr-1 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none">
                    Add item
                </button>
                <button v-if="!selectedCalendarView && canEdit" @click.prevent.stop="openCalendarView"
                        class="py-2 px-3 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none">
                    Save View
                </button>
                <button v-if="selectedCalendarView && canEdit" @click.prevent="editCalenderView"
                        class="py-2 px-3 mr-1 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none">
                    Edit View
                </button>
            </div>
            <!-- Scheduler Components added -->
            <scheduler class="left-container" :events="events" v-on:editEvent="editEvent"></scheduler>
            <!-- Scheduler Components added -->
        </div>
        <!-- Adding Buttons  -->
        <!-- Save Calendar View Modal -->
        <div class="modal" ref="saveCalendar" id="saveCalendarPatternModal" role="dialog">
            <div class="modal-dialog modal-md">
                <div class="modal-content">

                    <div v-if="this.editCalendarView" class="modal-header bg-teal text-white font-bold">
                        Edit Calendar Pattern Name
                    </div>
                    <div v-else class="modal-header bg-teal text-white font-bold">
                        Add Calendar Pattern Name
                    </div>
                    <div class="modal-body bg-white">
                        <input type="text"
                               class="text-grey-darkest w-full focus:outline-none p-2 text-base rounded-sm border-1"
                               placeholder="Type the Calendar name here..." v-model="calendarViewName"/>
                        <p class="error" v-if="calendarViewErrors.name">{{ calendarViewErrors.name }}</p>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-primary" @click.prevent="calendarView()">
                            Save
                        </button>
                        <button class="btn btn-link" type="reset" data-dismiss="modal">
                            Close
                        </button>
                    </div>

                </div>
            </div>
        </div>
        <!-- Save Calendar View Modal -->











        <!-- Add item Modal -->
        <div class="modal" id="addItem" role="dialog">
            <div class="modal-dialog modal-md">
                <div class="modal-content">
                    <div class="modal-header bg-teal text-white font-bold">
                        <span v-if="calendarStatus" class="modal-title">Edit Calendar Item</span>
                        <span v-else class="modal-title">New Calendar Item</span>
                        <button type="button" v-if="calendarStatus" class="close">
                            <i class="fa fa-trash" aria-hidden="true" style="color: red" @click="deleteEvent()"></i>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <form @keydown="form.errors.clear($event.target.name)">
                            <div v-if="!isContactBehavior && addItemFor" class="flex flex-wrap">
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('file_id')}">Select
                                        Project
                                    </label>
                                    <multiselect v-model="form.file_id" :options="this.fileList"
                                                 placeholder="Select Project" label="name"
                                                 track-by="id" @input="fetchFileUser"></multiselect>
                                    <div class="text-red text-xs" v-if="form.errors.has('file_id')">{{
                                            form.errors.get('file_id')
                                        }}
                                    </div>
                                    <div class="text-red text-xs" v-if="this.calendarErrorObj.file_id">{{
                                            this.calendarErrorObj.file_id
                                        }}
                                    </div>
                                    <p class="error" v-if="calendarItemErrors.file_id">{{
                                            calendarItemErrors.file_id
                                        }}</p>
                                </div>
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('file_id')}">Select
                                        Users
                                    </label>
                                    <multiselect v-model="form.user_id"
                                                 :options="this.itemUserList"
                                                 placeholder="Select Users" label="name"
                                                 track-by="id"></multiselect>
                                    <div class="text-red text-xs" v-if="form.errors.has('user_id')">{{
                                            form.errors.get('user_id')
                                        }}
                                    </div>
                                    <div class="text-red text-xs" v-if="this.calendarErrorObj.user_id">{{
                                            this.calendarErrorObj.user_id
                                        }}
                                    </div>
                                    <p class="error" v-if="calendarItemErrors.user_id">{{
                                            calendarItemErrors.user_id
                                        }}</p>
                                </div>
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('sales_id')}">Select
                                        Sales Activity</label>
                                    <multiselect v-model="form.sales_id" :options="this.salesBehaviourOptions"
                                                 placeholder="Select Sales Activity" label="name"
                                                 track-by="id">

                                    </multiselect>
                                    <div class="text-red text-xs" v-if="form.errors.has('sales_id')">{{
                                            form.errors.get('sales_id')
                                        }}
                                    </div>
                                    <div class="text-red text-xs" v-if="this.calendarErrorObj.sale_id">{{
                                            this.calendarErrorObj.sale_id
                                        }}
                                    </div>
                                    <p class="error" v-if="calendarItemErrors.sale_id">{{
                                            calendarItemErrors.sale_id
                                        }}</p>
                                </div>
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label v-if="form.sales_id.id !== -2 && form.sales_id.id !== -3" class="text-sm text-grey-darkest -mb-0" for="new_start_date"
                                           :class="{'text-red': form.errors.has('start_date')}">Start Date</label>
                                    <label v-else class="text-sm text-grey-darkest -mb-0" for="new_start_date"
                                           :class="{'text-red': form.errors.has('start_date')}">Date</label>
                                    <datetime type="datetime" id="new_start_date" name="date"
                                              v-model="form.start_date" use12-hour
                                              class="w-full"
                                              format="MM/d/yyyy hh:mm a"
                                              :minute-step="15"
                                              input-class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                              @input="form.errors.clear('start_date')">
                                    </datetime>
                                    <button v-if="form.start_date" @click.prevent.stop="removeStartDate"
                                            class="material-icons text-grey-darkest text-xl focus:outline-none cross-btn">
                                        clear
                                    </button>
                                    <div class="text-red text-xs" v-if="form.errors.has('start_date')">{{
                                            form.errors.get('start_date')
                                        }}
                                    </div>
                                    <div class="text-red text-xs" v-if="this.calendarErrorObj.start_date">{{
                                            this.calendarErrorObj.start_date
                                        }}
                                    </div>
                                    <p class="error" v-if="calendarItemErrors.start_date">
                                        {{ calendarItemErrors.start_date }}</p>
                                </div>
                                <div v-if="form.sales_id.id !== -2 && form.sales_id.id !== -3" class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-sm text-grey-darkest -mb-0" for="new_end_date"
                                           :class="{'text-red': form.errors.has('end_date')}">End Date</label>
                                    <datetime type="datetime" id="new_end_date" name="date"
                                              :min-datetime="form.start_date"
                                              v-model="form.end_date" use12-hour
                                              class="w-full"
                                              format="MM/d/yyyy hh:mm a"
                                              :minute-step="15"
                                              input-class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                              @input="form.errors.clear('end_date')">
                                    </datetime>
                                    <button v-if="form.end_date" @click.prevent.stop="removeEndDate"
                                            class="material-icons text-grey-darkest text-xl focus:outline-none cross-btn">
                                        clear
                                    </button>
                                    <div class="text-red text-xs" v-if="form.errors.has('end_date')">{{
                                            form.errors.get('end_date')
                                        }}
                                    </div>
                                    <div class="text-red text-xs" v-if="this.calendarErrorObj.end_date">{{
                                            this.calendarErrorObj.end_date
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-sm text-grey-darkest -mb-0 w-full" for="new_end_date"
                                           :class="{'text-red': form.errors.has('description')}">Description</label>
                                    <textarea v-model="form.description" rows="5"
                                              style="resize: none; border: 1px solid #dae1e7" class="w-full"/>
                                    <div class="text-red text-xs" v-if="form.errors.has('description')">{{
                                            form.errors.get('description')
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="addItemFor" class="flex flex-wrap">
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('contact_id')}">Select
                                        Contact
                                    </label>
                                    <multiselect v-model="form.contact_id" :options="allContacts"
                                                 placeholder="Select Contact" label="name"
                                                 :multiple="false"
                                                 :searchable="true"
                                                 track-by="id"></multiselect>
                                </div>
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('sales_id')}">Select
                                        Contact Activity</label>
                                    <multiselect v-model="form.contact_behavior_id" :options="allContactBehaviors"
                                                 placeholder="Select Contact Activity" label="name"
                                                 :multiple="false"
                                                 :searchable="true"
                                                 track-by="id">

                                    </multiselect>
                                </div>
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-sm text-grey-darkest -mb-0" for="new_start_date"
                                           :class="{'text-red': form.errors.has('start_date')}">Start Date</label>
                                    <datetime type="datetime" id="new_start_date" name="date"
                                              v-model="form.contact_behavior_date" use12-hour
                                              class="w-full"
                                              format="MM/d/yyyy hh:mm a"
                                              :minute-step="15"
                                              input-class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                              @input="form.errors.clear('start_date')">
                                    </datetime>
                                    <button v-if="form.contact_behavior_date" @click.prevent.stop="removeStartDate"
                                            class="material-icons text-grey-darkest text-xl focus:outline-none cross-btn">
                                        clear
                                    </button>
                                </div>
                            </div>
                            <div v-else>
                                <button class="btn btn-primary py-3" @click="() => { isContactBehavior = false; addItemFor = 'forAdd'; }">Add Project Sales Activity</button>
                                <button class="btn btn-primary py-3 float-right" @click="() => { isContactBehavior = true; addItemFor = 'forAdd'; }">Add Contact Activity</button>
                            </div>
                        </form>
                    </div>
                    <div v-if="addItemFor" class="d-flex modal-footer">
                        <button class="btn btn-link" type="reset" data-dismiss="modal">
                            Cancel
                        </button>
                        <button class="btn btn-primary" @click.prevent="addEventsToCalendar">
                            Add To Calendar
                        </button>
                        <button class="btn btn-primary" @click.prevent="downloadCalendarIcs">
                            <i class="fa fa-calendar"></i>
                        </button>
                        <a :href="baseUrl" v-if="calendarStatus && !isContactBehavior" class="btn btn-primary">Project Link</a>
                        <a v-else-if="calendarStatus && isContactBehavior && contactBaseUrl" :href="contactBaseUrl" class="btn btn-primary">Contact Link</a>
                    </div>
                </div>
            </div>
        </div>
        <!-- Add item Modal -->
        <!-- Share user Modal -->
        <div class="modal" id="shareUsers" role="dialog">
            <div class="modal-dialog modal-md">
                <div class="modal-content">
                    <div class="modal-header bg-teal text-white font-bold">
                        <span v-if="calendarStatus">Share Calendar View to Users</span>
<!--                        <span v-else>New Calendar Item</span>-->
                    </div>
                    <div class="modal-body bg-white">
                        <form @keydown="form.errors.clear($event.target.name)">
                            <div class="flex flex-wrap">
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('file_id')}">Select
                                        Users
                                    </label>
                                    <multiselect v-model="form.user_id"
                                                 :options="this.usersList"
                                                 placeholder="Select Users" label="name"
                                                 track-by="id" :multiple="true"></multiselect>
                                    <div class="text-red text-xs" v-if="form.errors.has('user_id')">{{
                                            form.errors.get('user_id')
                                        }}
                                    </div>
                                    <p class="error" v-if="calendarItemErrors.user_id">{{
                                            calendarItemErrors.user_id
                                        }}</p>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="d-flex modal-footer">
                        <button class="btn btn-link" type="reset" data-dismiss="modal">
                            Cancel
                        </button>
                        <button class="btn btn-primary" @click.prevent="shareCalandarViewToUsers">
                            Share
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Share user Modal -->
    </div>
</template>
<script>
import Form from "../../utils/form";
import Multiselect from 'vue-multiselect'
import Scheduler from './scheduler/scheduler';

export default {
    name: "calendar",
    components: {Scheduler, Multiselect},
    props: ['user', 'List', 'sales', 'behaviours', 'path', 'calendars', 'file', 'selectedUserIds', 'selectedSalesBehaviorIds', 'selectedView', 'selectedEvents', 'userRole', 'userCalendarSync', 'contactEvents', 'contactMeetingEvents', 'selectedContactActivities',
            'canEdit', 'canDelete'],
    data() {
        return {
            calendarStatus: true,
            calendarViewId: 0,
            calendarViewName: '',
            selectedCalendarView: '',
            fileList: [],
            calendarViewList: [],
            users: [],
            baseUrl: '',
            usersList: [],
            salesBehavior: [],
            selectedUserValue: [],
            selectedUserOptions: [],
            itemUserList: [],
            selectedSalesBehaviourOptions: [],
            salesBehaviourOptions: [],
            selectedSalesValue: [],
            messages: [],
            filterUserArray: [],
            filterSalesBehaviour: [],
            events: [],
            userObj: null,
            editCalendarView: false,
            calendarViewErrors: {
                'name': '',
            },
            calendarItemErrors: {
                'file_id': '',
                'user_id': '',
                'sale_id': '',
                'start_date': '',
            },
            form: new Form({
                'file_id': '',
                'sales_id': '',
                'user_id': '',
                'description': '',
                'start_date': '',
                'end_date': '',
                'meeting_id': '',
                'userTimeZoneName': null,
                'userTimeZoneOffset': null,
                'calendar': null,
                'project_id': null,
                'contact_id': null,
                'contact_behavior_id': null,
                'contact_behavior_date': '',
                'isContactBehavior': false,
                'oldContactBehaviorData': null,
            }),
            editDataObj:null,
            calendarObj: {

                'contact_email': '',
                'contact_name': '',
                'contact_phone': '',
                'time_zone': 'America/New_York',
                'time': {

                    'start': '',
                    'end': '',
                },
                'description': '',
                'location': '',
                'project_id': '',
                'project_name': '',
                'subject': '',
                'userTimeZoneName': null,
                'userTimeZoneOffset': null,
            },
            calendarErrorObj: {

                'file_id': '',
                'user_id': '',
                'sale_id': '',
                'start_date': '',
                'end_date': '',
            },
            alreadySynced: false,
            syncDate: null,
            userCalendarSyncData: this.userCalendarSync,
            allContactBehaviors: [],
            selectedContactBehavior: this.selectedContactActivities ?? [],
            filteredContactBehaviors: [],
            isContactBehavior: false,
            allContacts: [],
            contactBaseUrl:'',
            addItemFor: null,
            oldContactBehaviorData: null,
        }
    },
    mounted() {
        if(this.userCalendarSyncData){
            this.alreadySynced = true;
            this.syncDate = this.formatSyncDate(this.userCalendarSyncData.last_sync);
        }
        this.calendarViewList = this.calendars;
        this.users = this.user;
        this.usersList = this.List;
        this.salesBehavior = this.sales;
        this.fileList = this.file;
        this.getUserList();
        this.getSalesBehaviourList();

        if(this.selectedUserIds.length > 0){
            let userOptionArray = [];
            this.selectedUserIds.forEach(userListObj => {
                userOptionArray.push(userListObj);
            });
            this.selectedUserValue = userOptionArray;
        }
        if(this.selectedSalesBehaviorIds.length > 0){
            this.selectedSalesValue = this.selectedSalesBehaviorIds;
        }

        let defaultView = _.find(this.calendarViewList, { 'is_default' : 1 });
        if(defaultView !== undefined && defaultView !== null) {
            this.selectedCalendarView = defaultView;
            this.filterCalendarView(defaultView);
        }
        else if(this.selectedView != null) {
            this.calendarViewId = this.selectedView.id;
            this.selectedCalendarView = this.selectedView;
        }

        if(this.selectedEvents.length > 0) {
            let mappedEvents = [];
            mappedEvents = this.selectedEvents.map(salesObj => {
                return ({
                    'start_date': salesObj.startDate ? moment.utc(salesObj.startDate).local().format('YYYY-MM-DD HH:mm:ss') : '',
                    'end_date': salesObj.endDate ? moment.utc(salesObj.endDate).local().format('YYYY-MM-DD HH:mm:ss') : moment.utc(salesObj.startDate).local().format('YYYY-MM-DD HH:mm:ss'),
                    'text': salesObj.projectName + " - " + salesObj.salesBehaviourName ? salesObj.projectName + " - " + salesObj.salesBehaviourName : '',
                    'header': "<b>" + salesObj.projectName + "</b><br/>",
                    'color': salesObj.color ? salesObj.color : 'red',
                    "textColor": "#FFF",
                    "saleId": salesObj.salesBehaviourId,
                    "projectId": salesObj.projectId,
                    "projectName": salesObj.projectName,
                    "projectAddress": salesObj.projectAddress,
                    "salesBehaviourName": salesObj.salesBehaviourName,
                    "userId": salesObj.userId,
                    "userName": salesObj.userName,
                    "meetingId": salesObj.meetingId ?? null
                })

            });
            this.events = mappedEvents.filter(function(item){
               if(item !== undefined){
                   return item;
               }
            });
        }else{
            this.getUserEvents();
        }
        this.getUserSelectCalendar();
        this.formatContactEvents();
        this.getContactBehaviors();
        this.getContacts();
    },
    watch: {
        calendarViewName: {
            handler(calendarViewName) {
                if (calendarViewName !== "") {
                    this.calendarViewErrors.name = '';
                }
                // do stuff
            },
            deep: true
        },
        form: {
            handler(form) {
                if (form.file_id !== "") {
                    this.calendarItemErrors.file_id = '';
                    this.calendarErrorObj.file_id = '';
                }
                if (form.user_id !== "") {
                    this.calendarItemErrors.user_id = '';
                    this.calendarErrorObj.user_id = '';
                }
                if (form.sales_id !== "") {
                    this.calendarItemErrors.sale_id = '';
                    this.calendarErrorObj.sale_id = '';
                }
                if (form.start_date !== "") {
                    this.calendarItemErrors.start_date = '';
                    this.calendarErrorObj.start_date = '';
                }
                if (form.end_date !== "") {
                    this.calendarErrorObj.end_date = '';
                }
            },
            deep: true
        },
        user(nv) {
            if (!nv) {
                this.user = nv;
            }
        },
        List(nv) {
            if (!nv) {
                this.usersList = nv;
            }
        },
        sales(nv) {
            if (!nv) {
                this.salesBehavior = nv;
            }
        },
        app(nv) {
            //  console.log('nv', nv);
        },
        selectedUserValue(nv) {
            if (nv.length === 0) {
                this.filterUserArray = [];
            }
        },
        selectedSalesValue(nv) {
            if (nv.length === 0) {
                this.filterSalesBehaviour = [];
            }
        }
    },
    methods: {
        editEvent(data) {
            this.addItemFor = 'forEdit';
            if(data.isContactBehavior){
                this.oldContactBehaviorData = data;
                this.calendarStatus = true;
                this.isContactBehavior = true;
                this.$nextTick(() => {
                    this.form.reset();
                    this.getUserSelectCalendar();
                    this.calendarItemErrors = {
                        'file_id': '',
                        'user_id': '',
                        'sale_id': '',
                        'start_date': ''
                    };
                    if(data.isResidential){
                        let contactObj = {id: data.companyContactId, name: data.userName+' (Residential)'};
                        this.form.contact_id = contactObj;
                    }else{
                        let contactObj = {id: data.companyContactId, name: data.userName+' ('+data.companyName+')'};
                        this.form.contact_id = contactObj;
                    }

                    this.form.contact_behavior_id = this.allContactBehaviors.find(obj => obj.id === data.contactSaleBehavior);
                    this.form.contact_behavior_date = this.formatDate(data.start_date);
                    this.contactBaseUrl = this.path+'/company/'+ data.companyId+'/contact/'+data.companyContactId+'/edit';
                    $('#addItem').modal('show');
                });
            }else{
                this.isContactBehavior = false;
                if(data.meetingId && data.saleId === -1) {
                    this.salesBehaviourOptions = [{
                        id: -1,
                        name: 'Company FollowUp',
                        color: 'red'
                    }]
                }else{
                    this.salesBehaviourOptions = this.salesBehavior.filter(salesBehaviorObj => {
                        if(salesBehaviorObj.id !== -1) {
                            return ({
                                id: salesBehaviorObj.id,
                                name: salesBehaviorObj.name,
                                color: 'red'
                            })
                        }
                    });
                }

                this.form.reset();
                this.getUserSelectCalendar();
                this.calendarItemErrors = {
                    'file_id': '',
                    'user_id': '',
                    'sale_id': '',
                    'start_date': ''
                };
                this.userObj = {
                    id: data.userId,
                    name: data.userName,
                };
                this.fetchFileUser();
                this.baseUrl = this.path + '/project/' + data.projectId + '/edit?project=1';
                this.form.file_id = {
                    id: data.projectId,
                    name: data.projectName,
                    address: data.projectAddress,
                };
                this.form.sales_id = {
                    id: data.saleId,
                    name: data.salesBehaviourName,
                };
                this.form.meeting_id = data.meetingId ?? null;
                this.fetchEventDates(data);
                this.editDataObj = new Form({
                    project_id: data.projectId,
                    sale_id: data.saleId,
                    meeting_id: data.meetingId,
                    user_id: data.userId,
                    calendar: null
                });
            }
        },
        // Fetch Users List
        getUserList() {
            let self = this;
            let userOptionArray = [];
            self.usersList.forEach(userListObj => {
                userOptionArray.push({
                    id: userListObj.id,
                    name: userListObj.name,
                    color: userListObj.color
                });
            });

            self.selectedUserOptions = userOptionArray;
        },
        // Fetch Sales Behaviour
        getSalesBehaviourList() {
            this.selectedSalesBehaviourOptions = this.salesBehavior.map(salesBehaviorObj => {
                return ({
                    id: salesBehaviorObj.id,
                    name: salesBehaviorObj.name,
                    color: 'red'
                })
            });
            this.salesBehaviourOptions = this.selectedSalesBehaviourOptions
        },
        // Fetch Events
        getUserEvents() {
            let vue = this;
            this.events = this.behaviours.map(salesObj => {
                return ({
                    'start_date': salesObj.startDate ? moment.utc(salesObj.startDate).local().format('YYYY-MM-DD HH:mm') : '',
                    'end_date': salesObj.endDate ? moment.utc(salesObj.endDate).local().format('YYYY-MM-DD HH:mm') : moment.utc(salesObj.startDate).local().format('YYYY-MM-DD HH:mm:ss'),
                    'text': "<i>" + salesObj.projectName + " - " + salesObj.salesBehaviourName ? salesObj.projectName  + " - " + salesObj.salesBehaviourName : '' + "</i>",
                    'header': "<b>" + salesObj.projectName + "</b><br/>",
                    'color': salesObj.color ? salesObj.color : 'red',
                    'backgroundColor': salesObj.color ? salesObj.color : 'red',
                    "textColor": "#FFF",
                    "saleId": salesObj.salesBehaviourId,
                    "projectId": salesObj.projectId,
                    "projectName": salesObj.projectName,
                    "salesBehaviourName": salesObj.salesBehaviourName,
                    "userId": salesObj.userId,
                    "userName": salesObj.userName,
                    "meetingId": salesObj.meetingId ?? null
                })
            });
        },
        // Filter event with select of users and sales behaviour
        filterEvent() {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            let userOptionArray = [];
            this.selectedUserValue.forEach(userObj => {
                userOptionArray.push(userObj.id);
            });
            this.filterUserArray = userOptionArray;
            // this.filterUserArray = this.selectedUserValue.map(userObj => userObj.id);
            this.filterSalesBehaviour = this.selectedSalesValue.map(salesObj => salesObj.id);
            this.filteredContactBehaviors = this.selectedContactBehavior.map(contact => contact.id);
            if ((this.filterUserArray.length > 0 && this.filterSalesBehaviour.length > 0) || this.filteredContactBehaviors.length > 0) {
                axios({
                    method: 'post',
                    url: route('api.calendar.event.filter'),
                    data: {
                        userIds: this.filterUserArray,
                        salesBehaviourIds: this.filterSalesBehaviour,
                        contactBehaviors: this.filteredContactBehaviors
                    }
                }).then((res) => {
                    console.log(res);
                    if (res.status) {
                        this.events = [];
                        this.events = res.data.data.map(salesObj => {
                            return ({
                                'start_date': salesObj.startDate ? moment.utc(salesObj.startDate).local().format('YYYY-MM-DD HH:mm:ss') : '',
                                'end_date': salesObj.endDate ? moment.utc(salesObj.endDate).local().format('YYYY-MM-DD HH:mm:ss') : moment.utc(salesObj.startDate).local().format('YYYY-MM-DD HH:mm:ss'),
                                'text': salesObj.projectName + " - " + salesObj.salesBehaviourName ? salesObj.projectName + " - " + salesObj.salesBehaviourName : '',
                                'header': "<b>" + salesObj.projectName + "</b><br/>",
                                'color': salesObj.color ? salesObj.color : 'red',
                                "textColor": "#FFF",
                                "saleId": salesObj.salesBehaviourId,
                                "projectId": salesObj.projectId,
                                "projectName": salesObj.projectName,
                                "salesBehaviourName": salesObj.salesBehaviourName,
                                "userId": salesObj.userId,
                                "userName": salesObj.userName,
                                "meetingId": salesObj.meetingId ?? null,
                                "isContactBehavior": false,
                            })
                        });

                        let contactEvents = res.data.contactEvents.map(contactEvent => {
                            return ({
                                'start_date': contactEvent.date ? moment.utc(contactEvent.date).local().format('YYYY-MM-DD HH:mm:ss') : '',
                                'end_date': contactEvent.end_date ? moment.utc(contactEvent.end_date).local().format('YYYY-MM-DD HH:mm:ss') : moment.utc(contactEvent.date).local().format('YYYY-MM-DD HH:mm:ss'),
                                'text': contactEvent.name + " - " + contactEvent.contact_behavior_name ? contactEvent.name + " - " + contactEvent.contact_behavior_name : '',
                                'header': "<b>" + contactEvent.contact_behavior_name + "</b><br/>",
                                'textColor': '#FFF',
                                "color": this.getUserColor(contactEvent.user_id),
                                "contactBehaviourName": contactEvent.contact_behavior_name,
                                "userId": contactEvent.user_id,
                                "userName": contactEvent.name,
                                "contactBehaviorId": contactEvent.contact_behavior_id ?? null,
                                "isContactBehavior": true,
                                "companyContactId": contactEvent.company_contact_id,
                                "companyId": contactEvent.company_id,
                                "isResidential": contactEvent.is_residential,
                                "companyName": contactEvent.company_name,
                                "contactSaleBehavior": contactEvent.contact_sale_behaviors,
                            })
                        });

                        this.events = this.events.concat(contactEvents);

                        let contactMeetingEvent = res.data.contactMeetingEvents.map(contactEvent => {
                            return ({
                                'start_date': contactEvent.date ? moment.utc(contactEvent.date).local().format('YYYY-MM-DD HH:mm:ss') : '',
                                'end_date': contactEvent.date ? moment.utc(contactEvent.date).local().format('YYYY-MM-DD HH:mm:ss') : moment.utc(contactEvent.date).local().format('YYYY-MM-DD HH:mm:ss'),
                                'text': contactEvent.name + " - Follow Up" ? contactEvent.name + " - Follow Up": '',
                                'header': "<b> Follow Up </b><br/>",
                                'textColor': '#FFF',
                                "color": this.getUserColor(contactEvent.user_id),
                                "contactBehaviourName": "Follow Up",
                                "userId": contactEvent.user_id,
                                "userName": contactEvent.name,
                                "contactBehaviorId": contactEvent.meeting_id ?? null,
                                "isContactBehavior": true,
                                "companyContactId": contactEvent.company_contact_id,
                                "companyId": contactEvent.company_id,
                                "isResidential": contactEvent.is_residential,
                                "companyName": contactEvent.company_name,
                                "contactSaleBehavior": 0,
                            })
                        });

                        this.events = this.events.concat(contactMeetingEvent);

                    }
                }).catch((error) => {
                    console.log('errors', error);
                });
            } else {
                Toast.fire({
                    type: "error",
                    title: "Please Select Users & Sales Activity Or Contact Activity For Filtering Events."
                });
            }

        },
        removeCalenderView() {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });

            axios({
                method: 'post',
                url: route('api.calendar.delete.view'),
                data: {
                    id: this.calendarViewId,
                }
            }).then((res) => {
                if(res.data.status === 'success'){
                    this.getUserEvents();
                    this.selectedUserValue = [];
                    this.selectedSalesValue = [];
                    this.calendarViewList = this.calendarViewList.filter((item) =>{
                        if(item.id != this.calendarViewId){
                            return item;
                        }
                    });
                    this.selectedCalendarView = null;
                    this.calendarViewId = null;
                    Toast.fire({
                        type: "success",
                        title: res.data.message
                    });
                }else{
                    Toast.fire({
                        type: "error",
                        title: res.data.message
                    });
                }
            })
        },
        // Share Calendar view to users
        shareCalandarViewToUsers() {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            const userId = this.form.user_id;
            const shareViewObj =  {
                'userId':userId,
                'calendar_view_id': this.calendarViewId
            }
            if (userId === "") {
                this.calendarItemErrors.user_id = "Please Select User"
            }

            if (userId !== "") {

                axios({
                    method: 'post',
                    url: route('api.calendar.share.view'),
                    data: {
                        share_view_object: shareViewObj,
                    }
                }).then((res) => {
                    if (res.data.status == 'success'){
                        Toast.fire({
                            type: "success",
                            title: "Calendar View Shared Successfully"
                        });
                        $("#shareUsers").modal("hide");
                    }else{
                        Toast.fire({
                            type: "error",
                            title: res.data.message
                        });
                        $("#shareUsers").modal("hide");
                    }
                }).catch(error => {
                    console.log('error', error);
                });


            }
        },
        // Open Calendar View Pop up
        openCalendarView() {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            const calendarId = this.calendarViewId;
            if (calendarId === 0) {
                //this.events = [];
                if ((this.filterUserArray.length > 0 && this.filterSalesBehaviour.length > 0) || this.filteredContactBehaviors.length > 0) {
                    this.calendarViewErrors.name = '';
                    this.calendarViewName = '';
                    $("#saveCalendarPatternModal").modal("show");
                } else {
                    Toast.fire({
                        type: "error",
                        title: "Please Select Users & Sales Activity or Contact Activity."
                    });
                }
            } else {
                if ((this.filterUserArray.length > 0 && this.filterSalesBehaviour.length > 0) || this.filteredContactBehaviors.length > 0) {
                    this.filterEvent();
                    this.calendarView();
                } else {
                    Toast.fire({
                        type: "error",
                        title: "Please Select Users & Sales Activity or Contact Activity For Filtering Events."
                    });
                }
            }
        },
        // Open Up the Add Item Pop up
        openAddItem() {
            this.addItemFor = null;
            this.isContactBehavior = false;
            this.form.reset();
            this.getUserSelectCalendar();
            this.salesBehaviourOptions = this.salesBehavior.filter(salesBehaviorObj => {
                if(salesBehaviorObj.id !== -1) {
                    return salesBehaviorObj
                }
            });
            this.itemUserList = [];
            this.calendarStatus = false;
            this.calendarItemErrors = {
                'file_id': '',
                'user_id': '',
                'sale_id': '',
                'start_date': ''
            };
            $("#addItem").modal("show");
        },
        // Open up the Share view Pop up
        shareCalendarView() {
            this.form.reset();
            this.getUserSelectCalendar();
            this.calendarItemErrors = {
                'user_id': ''
            };
            $("#shareUsers").modal("show");
        },
        // Filter the calendar view which will be show on calendar events
        filterCalendarView(value) {
            if (this.selectedCalendarView != null) {
                this.calendarViewId = value.id;
            } else {
                this.calendarViewId = 0;
            }
            axios({
                method: 'post',
                url: route('api.calendar.filter.view'),
                data: {
                    id: this.calendarViewId,
                }
            }).then((res) => {
                this.selectedUserValue = [];
                this.selectedSalesValue = [];
                let userOptionArray = [];
                if (res.data.success) {
                    res.data.data.userIds.forEach(userId => {
                        userOptionArray.push(userId);
                    });
                    this.selectedUserValue = userOptionArray;
                    this.selectedSalesValue = res.data.data.salesBehavior;
                    this.selectedContactBehavior = res.data.data.contactBehaviorIds;
                    $("#addItem").modal("hide");
                    this.filterEvent();
                } else {
                    this.events = [];
                    this.selectedUserValue = [];
                    this.selectedSalesValue = [];
                    this.selectedContactBehavior = [];
                }
            }).catch((error) => {
                this.selectedUserValue = [];
                this.selectedSalesValue = [];
                this.selectedContactBehavior = [];
                console.log('error', error);
            });
        },
        //Fetch user from file
        fetchFileUser() {
            const fileData = this.form.file_id;
            if (fileData != null) {
                axios({
                    method: 'post',
                    url: route('api.calendar.get.file.user'),
                    data: {
                        id: this.form.file_id.id
                    }
                }).then((res) => {
                    this.itemUserList = [];
                    this.form.user_id = null;
                    if (this.userObj != null) {
                        this.form.user_id = this.userObj;
                    }
                    this.userObj = null;
                    if (res.data.success) {
                        this.itemUserList = res.data.data;
                    } else {
                        this.itemUserList = this.selectedUserOptions;
                    }
                }).catch((error) => {
                    console.log('error', error);

                });
            } else {
                this.itemUserList = [];
                this.form.user_id = "";
            }
        },
        //Calendar View
        calendarView() {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            let dataObj = "";
            if (this.calendarViewName === "") {
                this.calendarViewErrors.name = 'Please Provide Calendar Name';
            }
            dataObj = JSON.stringify({
                'userId': this.filterUserArray,
                'salesBehaviour': this.filterSalesBehaviour,
                'contactBehavior': this.filteredContactBehaviors,
            });
            if ((this.calendarViewName !== "" && this.filterUserArray.length > 0 && this.filterSalesBehaviour.length > 0) || (this.calendarViewName !== "" && this.filteredContactBehaviors.length > 0)) {
                this.updateCreateCalendarView(dataObj, this.calendarViewName);
            } else {
                if (this.calendarViewId !== 0) {
                    this.updateCreateCalendarView(dataObj, this.calendarViewName);
                }
            }
        },
        // Removing Start Date
        removeStartDate() {
            this.form.start_date = null;
            this.form.contact_behavior_date = null;
        },
        // Removing End Date
        removeEndDate() {
            this.form.end_date = null;
        },
        //adding events to calendar view
        addEventsToCalendar() {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            const fileId = this.form.file_id;
            const salesId = this.form.sales_id;
            const userId = this.form.user_id;
            const startDate = this.form.start_date;
            const endDate = this.form.end_date;
            if (fileId === "") {
                this.calendarItemErrors.file_id = "Please Select File"
            }
            if (userId === "") {
                this.calendarItemErrors.user_id = "Please Select User"
            }
            if (salesId === "") {
                this.calendarItemErrors.sale_id = "Please Select Activity"
            }
            if (startDate === "") {
                this.calendarItemErrors.start_date = "Please Select Start Date"
            }

            if(this.isContactBehavior){
                if(!this.form.contact_id){
                    this.getToast().fire({
                        type: 'error',
                        title: 'Please select a contact'
                    });
                    return false;
                }

                if(!this.form.contact_behavior_id){
                    this.getToast().fire({
                        type: 'error',
                        title: 'Please select a contact activity'
                    });
                    return false;
                }

                if(!this.form.contact_behavior_date){
                    this.getToast().fire({
                        type: 'error',
                        title: 'Please add start date'
                    });
                    return false;
                }
            }

            this.form.project_id = this.form.file_id.id;
            this.form.userTimeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
            this.form.userTimeZoneOffset = new Date().getTimezoneOffset();
            this.form.isContactBehavior =  this.isContactBehavior;
            this.form.oldContactBehaviorData =  this.oldContactBehaviorData;
            if ((fileId !== "" && salesId !== "" && userId !== "" && startDate !== "") || (this.form.contact_behavior_date !== '' && this.form.contact_behavior_id && this.form.contact_id)) {
                this.form.post(route('api.calendar.add.item')).then((response) => {
                    this.selectedUserValue = this.selectedUserOptions.filter(user => user.id === this.form.user_id.id);
                    this.selectedSalesValue = this.selectedSalesBehaviourOptions.filter(sales => sales.id === this.form.sales_id.id);
                    this.filterEvent();
                    $("#addItem").modal("hide");
                    Toast.fire({
                        type: "success",
                        title: "Item has been saved"
                    });
                    window.location.reload();
                }).catch(error => {
                    console.log('error', error);
                });
            }
        },
        //Fetch dates of single events
        fetchEventDates() {
            axios({
                method: 'post',
                url: route('api.calendar.get.event.dates'),
                data: {
                    file_id: this.form.file_id,
                    sales_id: this.form.sales_id,
                    user_id: this.form.user_id,
                    meeting_id: this.form.meeting_id ?? null,
                }
            }).then((res) => {
                console.log('=============================================================>', res);
                if (res.data.success) {
                    this.form.start_date = res.data.data.start_date;
                    this.form.end_date = res.data.data.end_date;
                }

                this.calendarStatus = true;
                $("#addItem").modal("show");
            }).catch((error) => {
                console.log('error', error);

            });
        },
        // Saving or updating Multiple Calendar View
        updateCreateCalendarView(dataObj, calendarViewName) {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            axios({
                method: 'post',
                url: route('api.calendar.save.view'),
                data: {
                    calendarId: this.calendarViewId,
                    name: calendarViewName,
                    pattern: dataObj
                }
            }).then((res) => {
                if (res.data.success) {
                    this.calendarViewList = res.data.data;
                    if (this.calendarViewId != 0){
                        this.selectedCalendarView = _.find(this.calendarViewList, [ 'id' , this.calendarViewId ]);
                    }
                    $("#saveCalendarPatternModal").modal("hide");
                    Toast.fire({
                        type: "success",
                        title: res.data.message
                    });
                } else {
                    Toast.fire({
                        type: "error",
                        title: res.data.message
                    });
                }
            }).catch((error) => {
                console.log('error', error);

            });
        },

        downloadCalendarIcs(){
            if(this.isContactBehavior){
                if(!this.form.contact_id){
                    this.getToast().fire({
                        type: 'error',
                        title: 'Please select a contact'
                    });
                    return false;
                }

                if(!this.form.contact_behavior_id){
                    this.getToast().fire({
                        type: 'error',
                        title: 'Please select a contact activity'
                    });
                    return false;
                }

                if(!this.form.contact_behavior_date){
                    this.getToast().fire({
                        type: 'error',
                        title: 'Please add start date'
                    });
                    return false;
                }
                this.calendarObj.project_id = this.form.file_id.id;
                this.calendarObj.time.start = moment(this.form.contact_behavior_date).utc(1).format("YYYY-MM-DD HH:mm");
                this.calendarObj.time.end = moment(this.form.contact_behavior_date).utc(1).add(30, 'minutes').format("YYYY-MM-DD HH:mm");
                this.calendarObj.project_name = this.form.contact_id.name;
                this.calendarObj.location = '';
                this.calendarObj.subject = this.form.contact_behavior_id.name;
            }else{
                if (this.form.file_id === null || this.form.file_id === undefined || this.form.file_id === "") {

                    this.calendarErrorObj.file_id = 'Please select a project';
                    return false;
                }

                if (this.form.user_id === null || this.form.user_id === undefined || this.form.user_id === "") {

                    this.calendarErrorObj.user_id = 'Please select a user';
                    return false;
                }

                if (this.form.sales_id === null || this.form.sales_id === undefined || this.form.sales_id === "") {

                    this.calendarErrorObj.sale_id = 'Please select a sale behaviour';
                    return false;
                }

                if (this.form.start_date === null || this.form.start_date === undefined || this.form.start_date === "") {

                    this.calendarErrorObj.start_date = 'Please select a start date';
                    return false;
                }

                if (this.form.end_date === null || this.form.end_date === undefined || this.form.end_date === "") {

                    this.calendarErrorObj.end_date = 'Please select a end date';
                    return false;
                }

                this.calendarObj.project_id = this.form.file_id.id;
                this.calendarObj.time.start = moment(this.form.start_date).utc(1).format("YYYY-MM-DD HH:mm");
                this.calendarObj.time.end = moment(this.form.end_date).utc(1).format("YYYY-MM-DD HH:mm");
                this.calendarObj.project_name = this.form.file_id.name;
                this.calendarObj.location = this.form.file_id.address !== null ? this.form.file_id.address : '';
                this.calendarObj.subject = this.form.sales_id.name;
            }


            this.calendarObj.description = this.form.description !== null ? this.form.description : '';
            this.calendarObj.userTimeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
            this.calendarObj.userTimeZoneOffset = new Date().getTimezoneOffset();

            axios.post(route('external-email.calendar-file-download'), this.calendarObj)
                .then((data) => {
                    window.location = data.data;
                });
        },

        removeSelectedUserValue(user){
            this.selectedUserValue = _.remove(this.selectedUserValue, function(currentObject) {
                return currentObject.id !== user.id;
            });
        },
        removeSelectedSalesValue(sale){
            this.selectedSalesValue = _.remove(this.selectedSalesValue, function(currentObject) {
                return currentObject.id !== sale.id;
            });
        },
        deleteEvent(){
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            if(this.isContactBehavior){
                let data = {};
                data.contactBehavior = this.form.contact_behavior_id;
                data.contactBehavior.contact = this.form.contact_id;
                data.contactBehavior.userTimeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
                data.contactBehavior.userTimeZoneOffset = new Date().getTimezoneOffset();
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#01B1AF',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        axios.post(route('api.calendar.delete.item'), data).then((response) => {
                            window.location.reload();
                        });
                    }
                });
            }else{

                let data = this.editDataObj;
                const fileId = data.project_id;
                const salesId = data.sales_id;
                const userId = data.user_id;
                this.getUserSelectCalendar();
                data.calendar = this.form.calendar;
                data.contactBehavior = null;
                if (fileId !== "" && salesId !== "" && userId !== "") {
                    Swal.fire({
                        title: 'Are you sure?',
                        text: "You won't be able to revert this!",
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#01B1AF',
                        confirmButtonText: 'Yes, delete it!'
                    }).then((result) => {
                        if (result.value) {
                            data.post(route('api.calendar.delete.item')).then((response) => {
                        console.log(response)
                        $("#addItem").modal("hide");
                        this.filterEvent();
                        Toast.fire({
                            type: "success",
                            title: "Item has been Deleted"
                        });
                    }).catch(error => {
                        console.log('error', error);
                    });
                        }
                    });
                }
            }
        },
        // Edit View Calender
        editCalenderView(){
            let calendarView = _.find(this.calendarViewList, [ 'id' , this.calendarViewId ]);
            this.filterUserArray = this.selectedUserValue.map(userObj => userObj.id);
            this.filterSalesBehaviour = this.selectedSalesValue.map(salesObj => salesObj.id);
            this.calendarViewName   = calendarView.name;
            this.editCalendarView = true;
            $("#saveCalendarPatternModal").modal("show");
        },
        getUserSelectCalendar(){
            axios.post(route('calendar.get-user-selected-calendar')).then((response) => {
                this.form.calendar = response.data;
            });
        },
        formatSyncDate(lastSync){
            return moment.utc(lastSync).local().format('MM/DD/YYYY hh:mm A');
        },
        connectExternalMail(){
            window.location.href = '/settings#/calendar-sync'
        },
        getContactBehaviors(){
            axios.post(route('calendar.get-contact-behaviors-for-calendar')).then((response) => {
                this.allContactBehaviors = response.data.allContactBehaviors;
                this.allContactBehaviors.push({
                    'id': 0,
                    'name': 'Follow Up',
                    'color': null
                });
            });
        },
        getContacts(){
            axios.post(route('calendar.get-contact-for-calendar')).then((response) => {
                this.allContacts = response.data.allContacts;
            });
        },
        removeSelectedContact(contact){
            this.selectedContactBehavior = _.remove(this.selectedContactBehavior, function(currentObject) {
                return currentObject.id !== contact.id;
            });
        },
        formatDate(dateString){
            const originalDate = new Date(dateString);
            const year = originalDate.getUTCFullYear();
            const month = (originalDate.getUTCMonth() + 1).toString().padStart(2, '0');
            const day = originalDate.getUTCDate().toString().padStart(2, '0');
            const hours = originalDate.getUTCHours().toString().padStart(2, '0');
            const minutes = originalDate.getUTCMinutes().toString().padStart(2, '0');
            const seconds = originalDate.getUTCSeconds().toString().padStart(2, '0');

            return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.000Z`;

        },
        formatContactEvents(){
            if(this.contactEvents.length > 0){
                let contactEvents = this.contactEvents.map(contactEvent => {
                    return ({
                        'start_date': contactEvent.date ? moment.utc(contactEvent.date).local().format('YYYY-MM-DD HH:mm:ss') : '',
                        'end_date': contactEvent.end_date ? moment.utc(contactEvent.end_date).local().format('YYYY-MM-DD HH:mm:ss') : moment.utc(contactEvent.date).local().format('YYYY-MM-DD HH:mm:ss'),
                        'text': contactEvent.name + " - " + contactEvent.contact_behavior_name ? contactEvent.name + " - " + contactEvent.contact_behavior_name : '',
                        'header': "<b>" + contactEvent.contact_behavior_name + "</b><br/>",
                        'textColor': '#FFF',
                        "color": this.getUserColor(contactEvent.user_id),
                        "contactBehaviourName": contactEvent.contact_behavior_name,
                        "userId": contactEvent.user_id,
                        "userName": contactEvent.name,
                        "contactBehaviorId": contactEvent.contact_behavior_id ?? null,
                        "isContactBehavior": true,
                        "companyContactId": contactEvent.company_contact_id,
                        "companyId": contactEvent.company_id,
                        "isResidential": contactEvent.is_residential,
                        "companyName": contactEvent.company_name,
                        "contactSaleBehavior": contactEvent.contact_sale_behaviors,
                    })
                });

                this.events = this.events.concat(contactEvents);

            }
            if(this.contactMeetingEvents.length > 0){
                let contactEvents = this.contactMeetingEvents.map(contactEvent => {
                    return ({
                        'start_date': contactEvent.date ? moment.utc(contactEvent.date).local().format('YYYY-MM-DD HH:mm:ss') : '',
                        'end_date': contactEvent.date ? moment.utc(contactEvent.date).local().format('YYYY-MM-DD HH:mm:ss') : moment.utc(contactEvent.date).local().format('YYYY-MM-DD HH:mm:ss'),
                        'text': contactEvent.name + " - Follow Up" ? contactEvent.name + " - Follow Up": '',
                        'header': "<b> Follow Up </b><br/>",
                        'textColor': '#FFF',
                        "color": this.getUserColor(contactEvent.user_id),
                        "contactBehaviourName": "Follow Up",
                        "userId": contactEvent.user_id,
                        "userName": contactEvent.name,
                        "contactBehaviorId": contactEvent.meeting_id ?? null,
                        "isContactBehavior": true,
                        "companyContactId": contactEvent.company_contact_id,
                        "companyId": contactEvent.company_id,
                        "isResidential": contactEvent.is_residential,
                        "companyName": contactEvent.company_name,
                        "contactSaleBehavior": 0,
                    })
                });

                this.events = this.events.concat(contactEvents);

            }
        },
        getUserColor(userId){
            let foundObject = this.usersList.find(function(obj) {
                return obj.id === userId;
            });
            if(foundObject){
                return foundObject.color;
            }else{
                return  "#01b1af";
            }

        },
        manageDefaultView() {
            let self = this;
            axios.post(route('api.calendar.manage-default.view'), {view: self.selectedCalendarView}).then((response) => {
                self.calendarViewList = response.data.calendarViewList;
                self.selectedCalendarView = response.data.selectedView;
            });
        }
    }
}
</script>
<style scoped>

.py-4 container {
    max-width: 100% !important;
}


.left-container {
    overflow: hidden;
    overflow-x: hidden;
    position: relative;
    height: 800px !important;
    border: 1px solid #e8e8e8;
    margin-top: 10px;
}

.right-container {
    border-right: 1px solid #cecece;
    float: right;
    height: 100%;
    width: 340px;
    box-shadow: 0 0 5px 2px #aaa;
    position: relative;
    z-index: 2;
}

.scheduler-messages {
    list-style-type: none;
    height: 50%;
    margin: 0;
    overflow-x: hidden;
    overflow-y: auto;
    padding-left: 5px;
}

.scheduler-messages > .scheduler-message {
    background-color: #f4f4f4;
    box-shadow: inset 5px 0 #d69000;
    font-family: Geneva, Arial, Helvetica, sans-serif;
    font-size: 14px;
    margin: 5px 0;
    padding: 8px 0 8px 10px;
}

.selectedSalesBehaviour {
    cursor: pointer;
    background-color: #01b1af;
    display: flow-root;
    padding: 5px;
    border-radius: 5px;
    text-align: center;
    color: #fff;
    margin-top: 5px;
}

label {
    display: inline-block;
    margin-bottom: .5rem;
    font-weight: 500;
    color: #000;
}

.selected-filters {
    max-height: 250px;
    overflow: scroll;
    height: auto;
    overflow-y: auto;
    overflow-x: hidden;
}

/* Scrollbar Styling */
::-webkit-scrollbar {
    width: 5px;
}

::-webkit-scrollbar-track {
    background-color: #ebebeb;
    -webkit-border-radius: 10px;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: #6d6d6d;
}

.multiselect .multiselect__tags {
    border: 1px solid #ced4da !important;
    min-height: 38px !important;
    max-height: 150px !important;
    overflow: scroll;
    overflow-x: hidden;
    overflow-y: auto;
}

/*event in day or week view*/
.dhx_cal_event.colored-event div {
    color: #FFFFFF !important;
}

/*multi-day event in month view*/
.dhx_cal_event_line.colored-event {
    color: #FFFFFF !important;
}

/*single-day event in month view*/
.dhx_cal_event_clear.colored-event {
    color: #FFFFFF !important;
}

.calender-name-multi-select[data-v-f116d698] {
    margin-left: auto;
    width: 350px;
    margin-left: inherit;
    height: 34px;
    padding: 0px 10px;
}

.add-item-save-btn-main-div {
    justify-content: flex-end;
}

button.cross-btn {
    margin-left: auto;
    margin-top: -36px;
    margin-right: 10px;
}

.multiselect.calender-filter {
    width: 60%;
    margin-left: auto;
}

.error {
    color: red;
    font-size: 11px;
    margin-left: 3px;
    margin-top: 5px;
}
.closeSelectItems {
    float: right;
    margin-right: 0px;
    overflow: hidden;
    padding: 0 10px;
    cursor: pointer;
}

.closeSelectItems:hover {
    background: #bbb;
    border-radius: 5px;
}
</style>
